import React, { useState } from "react"
const AnbarGardaniForm=(props)=>{
    
    return(
        <React.Fragment>
          
{console.log(props.anbargardani)}
<div className="row">
    <div className="container">
<div className="col-12">
    <span className="d-inline-block text-white">  انتخاب انبارگردانی </span>
    <select className="form-control" onChange={props.selectAnbargardani}>
    <option value={0}>انتخاب کنید</option>

        {
             props.anbargardani!=undefined &&    props.anbargardani!=null && props.anbargardani.map((item, index) => {return(
                <option value={item.id}>{item.title}</option>) 
            })
        } 
    </select>
</div>

<div className="col mt-4">
    <div className="btn btn-block btn-dark" onClick={props.applyAnbargardani}>انتخاب انبارگردانی </div>
</div>
</div> 
</div>
            </React.Fragment>
        )
}
export default AnbarGardaniForm;